import { render, staticRenderFns } from "./RsaPazienteProgettoSocioRiabilitativoPage.vue?vue&type=template&id=b0f60528"
import script from "./RsaPazienteProgettoSocioRiabilitativoPage.vue?vue&type=script&lang=js"
export * from "./RsaPazienteProgettoSocioRiabilitativoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports